// 03f59dbf4c72a1615507e5fb9430dfb1d0b1 -> 03:f5:9d:bf:4c:72:a1:61:55:07:e5:fb:94:30:df:b1:d0:b1
export const formatCertSerial = (serial: string) => {
  return serial
    .split(/(..)/)
    .filter(Boolean)
    .join(`:`)
}
